"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FluidFormElementType = void 0;
var FluidFormElementType;
(function (FluidFormElementType) {
    FluidFormElementType["INPUT"] = "input";
    FluidFormElementType["CURRENCY"] = "currency";
    FluidFormElementType["TEXTAREA"] = "textarea";
    FluidFormElementType["DATEPICKER"] = "date";
    FluidFormElementType["RADIO_GROUP"] = "radio-group";
    FluidFormElementType["TOGGLE"] = "toggle";
    FluidFormElementType["TOGGLE_GROUP"] = "toggle-group";
    FluidFormElementType["SELECT"] = "select";
    FluidFormElementType["ARRAY"] = "array";
    FluidFormElementType["COMBO_BOX"] = "combo-box";
    FluidFormElementType["HIDDEN"] = "hidden";
    FluidFormElementType["ADDRESS_FORM"] = "address-form";
    FluidFormElementType["RATING"] = "rating";
    FluidFormElementType["RICH_TEXT_EDITOR"] = "rich-text-editor";
    FluidFormElementType["DATE_TIME"] = "date-time";
})(FluidFormElementType = exports.FluidFormElementType || (exports.FluidFormElementType = {}));
